import axios from "axios";
import { storeUrl } from "../url";
const API = axios.create({
  baseURL: storeUrl , // change this to your backend URL or http://localhost:8000
  withCredentials: true, // ✅ allows sending httpOnly cookies
});

/* ---------------------------- CLIENT API's ---------------------------- */
export const getNewArrivals = () => API.get("/new");
export const getClientProducts = (data) => API.post("/getProducts", data);
export const getProduct = (id) => API.get(`/getProduct?id=${id}`);
export const getBlogs = ()=> API.get('/getBlogs');
export const setRatingsAndReviews = (data) => API.post("/setRatingsnReviews", data);
export const getSearchResult = (query) => API.get(`/searchResult?query=${query}`);

/* -------------------------- AUTHENTICATION ---------------------------- */
export const login = (formData) => API.post("/login", formData);
export const authenticate = () => API.get("/auth");
export const logout = () => API.post("/logout");
export const createAccount = (formData) => API.post("/createAccount", formData);
export const sendOtp = (email)=> API.post('/otp/send', {email});
export const verifyOtp = (email, otp)=> API.post('/otp/verify', { email, otp }, { withCredentials: true });

/* ----------------------------- USER API's ----------------------------- */
export const savePersonalInfo = (data) => API.post("/savePersonalInfo", data);
export const getPersonalInfo = () => API.get("/getPersonalInfo");

export const getUserAddresses = () => API.get("/getUserAddresses");
export const saveAddress = (data) => API.post("/saveAddress", data);
export const deleteSavedAddress = (id) => API.delete(`/deleteSavedAddress?id=${id}`);

export const getUserOrders = () => API.get("/getUserOrders");
export const getSearchedUserOrders = (query) =>
  API.get(`/getSearchedUserOrders?query=${query}`);

export const addToWishlist = (data) => API.post("/addToWishlist", data);
export const getWishlistData = () => API.get("/getWishlistData");
export const deleteFromWishlist = (id) => API.delete(`/deleteFromWishlist?id=${id}`);

/* ------------------------------ CART API's ---------------------------- */
export const cartHandler = (data) => API.post("/cartHandler", data);
export const getCartData = () => API.get("/cartData");
export const itemQuantityHandler = (data) => API.post("/itemQuantityHandler", data);
export const getHeaderCartData = () => API.get("/headerCartData");

/* ------------------------------ SYNC API's ---------------------------- */

export const syncUserData = (payload)=> API.post('/sync-data',payload);
export const getUserData = (email)=> API.get(`/user-data/${email}`)

/* ---------------------------- NEWSLETTER ----------------------------- */
export const sendNewsletter = (data) => API.post("/newsletter", data);
export const getCustomerEnquiry =(data) =>API.post('/getEnquiry', data)

/* --------------------------- GEOLOCATION ----------------------------- */
export const getCurrentLocation = (coords) =>
  API.post("/geocode", coords); // e.g., { lat, lon }

/* ----------------------------- PAYMENT ------------------------------- */
export const createOrder = (data) => API.post("/createOrder", data);
export const verifyPayment = (data) => API.post("/verifypayment", data);
export const paymentFailure = (data) => API.post("/paymentFailure", data);

/* -------------------------- EXPORT DEFAULT --------------------------- */
export default API;
